import { Outlet } from 'react-router-dom';

import { useUserProfile } from '@/states/user-profile';

import { GlobalHeader } from './global-header';
import { SideMenu } from './navigation/side-menu';
import { SidebarProvider } from './providers/sidebar-provider';
import { SidebarInset } from './ui/sidebar';
import { AISearchAgent } from './ai-search-tool/ai-search-agent';

export function MainLayout() {
  const { profile } = useUserProfile();
  const isVitaziAdmin = profile?.role === 'vitaziadmin';

  return (
    <SidebarProvider>
      <SideMenu />
      <SidebarInset>
        <GlobalHeader />
        <div className="w-full max-w-screen overflow-auto xl:max-w-7xl xl:mx-auto relative">
          <Outlet />
          {isVitaziAdmin ? <AISearchAgent /> : null}
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
